export const INVENTORY_ENDPOINT = 'inventory';
